/** Wire types, mirroring `entrypoints/api/schemas/blocks.py`. */

export interface BlockSummary {
  slug: string;
  name: string;
  tagline: string;
  category: string;
  version: string;
  has_image: boolean;
  /** False when the block works the moment it is installed. */
  needs_configuration: boolean;
  has_fake: boolean;
  requires: string[];
}

export interface FileEntry {
  path: string;
  role: string;
  description: string;
}

export interface EnvEntry {
  name: string;
  description: string;
  required: boolean;
  secret: boolean;
  default: string;
}

export interface WiringEntry {
  target: string;
  description: string;
  code: string;
}

export interface BlockDetail extends BlockSummary {
  description: string;
  files: FileEntry[];
  env: EnvEntry[];
  pip: string[];
  wiring: WiringEntry[];
  reference: { label: string; url: string } | null;
  dependencies: BlockSummary[];
}

/** Accent per category. The block images use the same hues, so a card and its
 *  artwork read as one object rather than a picture in a box. */
export const CATEGORY_ACCENT: Record<string, string> = {
  identity: "var(--color-accent-identity)",
  persistence: "var(--color-accent-persistence)",
  storage: "var(--color-accent-storage)",
  ai: "var(--color-accent-ai)",
  messaging: "var(--color-accent-messaging)",
  observability: "var(--color-accent-observability)",
  packaging: "var(--color-accent-packaging)",
};

export function accentFor(category: string): string {
  return CATEGORY_ACCENT[category] ?? "var(--color-accent-default)";
}
